<template>
  <sonicu-button
    bg-color="bg-purple-600"
    @click="sendCalibrate"
  >
    <span v-if="ajaxPollingData">
      <loading></loading>
    </span>
    <span v-else>
      Force CO2 Calibration = 0
    </span>
  </sonicu-button>
</template>

<script>
import SonicuButton from "@/components/elements/buttons/SonicuButton";
import Loading from "@/components/elements/loading";
import {get} from "axios";
export default {
  name: "ProbeCalibrationCo2Calibrate",
  components: {Loading, SonicuButton},
  props:{
    companyId:{
      type: String,
      required: true
    },
    zoneId:{
      type: String,
      required: true
    },
  },
  data(){
    return {
      ajaxPollingData: false,
    };
  },
  computed: {
    href(){
      return '/api-internal/' + this.companyId + '/probe-calibration/co2-calibrate/' + this.zoneId;
    },
  },
  methods: {
    sendCalibrate(){
      this.ajaxPollingData = true;
      get(this.href)
        .then((response) => {
          this.ajaxPollingData = false;
        })
        .catch((error) => {
          this.ajaxPollingData = false;
        });
    }
  }
}
</script>

<style scoped>

</style>